export default function PaymentDetails({ order }) {
  return (
    <dl className="admin-payment-details">
      <div><dt>Payment</dt><dd>{order.paymentMethod === 'cod' ? 'Cash on Delivery' : 'Razorpay'}</dd></div>
      <div><dt>Payment status</dt><dd>{order.paymentStatus.replaceAll('_', ' ')}</dd></div>
      <div><dt>Order status</dt><dd>{order.status.replaceAll('_', ' ')}</dd></div>
    </dl>
  );
}
